//
// PageSetup.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./PageSetupSize";
import "./PageSetupOrientation";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "./PageSetupPageFit";

var PageSetup = createModule("BIRD::PageSetup", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        orientation: 4,
        startingNumber: 4,
        offsetHeader: 1,
        marginLeft: 1,
        marginRight: 1,
        size: 4,
        printBackgroundColorsAndImages: 2,
        width: 7,
        pageFit: 4,
        marginBottom: 1,
        offsetFooter: 1,
        marginTop: 1,
        height: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default PageSetup;
